export { Benefits } from './Benefits';
export { FAQ } from './FAQ';
export { Partners } from './Partners';
export { SpecialOffer } from './SpecialOffer';
export { FeedbackCards } from './FeedbackCards';
export { BlurredReport } from './BlurredReport';
export { UserDetails } from './UserDetails';
export { TimerBanner } from './TimerBanner';
